import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, flexDirection, alignItems } from '../../styles/helpers/flexbox';

const ModalBody = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  ${flexbox()};
  ${flexDirection('column')};
  ${alignItems('flex-start')};
  height: 100%;

  * {
    color: ${colours.grey[900]};
  }

  .pipe {
    color: ${colours.grey[300]};
    font-size: 30px;
    margin: 0 10px;
  }
  `;
});

const Header = styled.div(() => `
    margin-bottom: 15px;
    font-size: 18px;
    ${flexbox()};
    ${alignItems('center')};
    
    div[class*='svgIconComponent--'] {
      width: auto;
      margin-right: 20px;
      pointer-events: auto;
      cursor: pointer;

      & > span.isvg {
        ${flexbox()};
      }
    }
  `);

const Content = styled.div(() => `
    border: 1px solid #E6E9EA;
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 15px;
    text-align: left;
    font-size: 15px;
    overflow-y: auto;
    flex-grow: 1;
  `);

const Footer = styled.div`
  padding-top: 20px;
  margin: 0 auto;

  & > div[role="button"] {
    padding: 5px 50px;
    color: white;
  }
`;

export { ModalBody, Header, Content, Footer };
